import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import { TooltipProvider } from "./components/ui/tooltip";
import ProtectedRoute from "./components/ProtectedRoute";
import Navbar from "./components/Navbar";
import AuthCallback from "./pages/AuthCallback";
import LandingPage from "./pages/LandingPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import Dashboard from "./pages/Dashboard";
import CreateAssessment from "./pages/CreateAssessment";
import AssessmentResults from "./pages/AssessmentResults";
import AssessmentSettingsPage from "./pages/AssessmentSettingsPage";
import InviteCandidates from "./pages/InviteCandidates";
import CandidateAssessment from "./pages/CandidateAssessment";

function AppRouter() {
  const location = useLocation();

  if (location.hash?.includes("id_token=")) {
    return <AuthCallback />;
  }

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/create-assessment" element={<ProtectedRoute><CreateAssessment /></ProtectedRoute>} />
        <Route path="/assessments/:id/results" element={<ProtectedRoute><AssessmentResults /></ProtectedRoute>} />
        <Route path="/assessments/:id/settings" element={<ProtectedRoute><AssessmentSettingsPage /></ProtectedRoute>} />
        <Route path="/assessments/:id/invite" element={<ProtectedRoute><InviteCandidates /></ProtectedRoute>} />
        <Route path="/take/:token" element={<CandidateAssessment />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <TooltipProvider>
          <AppRouter />
        </TooltipProvider>
        <Toaster position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
